module.exports = __webpack_public_path__ + "img/sto_rtt3.1fe70a00.jpg";